import { BooleanCons, NumberCons, StringConst } from 'src/app/constants/const';
import { BaseResponseHttp } from './commons.model';

export class IClientDoctorRes extends BaseResponseHttp {
  response?: ClientDoctorModel[];
}

export class ClientDoctorModel {
  name: string;
  photoUrl: string;
  speciality: string;
  telephone: string;
  mobile: string;
  professionalLicense: string;
  email: string;
  address: string;
  billingInfo: BillingInfo;
  pendingOrders: number;
  activeOrders: number;
  deliveredOrders: number;
  cardCode: string;
  isRegisteredOurSystem: boolean;
  averageTicketDesc: string;
  initialsName: string | undefined;
  priceList: string;
  creditInfo: CreditInfo | undefined;
  clientType: string;
  constructor() {
    this.name = StringConst.empty;
    this.photoUrl = StringConst.empty;
    this.speciality = StringConst.empty;
    this.telephone = StringConst.empty;
    this.mobile = StringConst.empty;
    this.professionalLicense = StringConst.empty;
    this.email = StringConst.empty;
    this.address = StringConst.empty;
    this.billingInfo = new BillingInfo();
    this.pendingOrders = NumberCons.zero;
    this.activeOrders = NumberCons.zero;
    this.cardCode = StringConst.empty;
    this.isRegisteredOurSystem = false;
    this.averageTicketDesc = StringConst.empty;
    this.deliveredOrders = NumberCons.zero;
    this.priceList = StringConst.empty;
    this.clientType = StringConst.empty;
    this.creditInfo = new CreditInfo();
  }
}
export class CheckShoppingAndAdviser {
  isHeaderClient: boolean;
  isShoppingCartShow: boolean;
  constructor() {
    this.isHeaderClient = false;
    this.isShoppingCartShow = false;
  }
}

export class RouteView {
  routes: string[];
  view: CheckShoppingAndAdviser;
  constructor() {
    this.routes = [];
    this.view = new CheckShoppingAndAdviser();
  }
}
export class ClientAdviser {
  name: string;
  photoUrl: string;
  speciality: string;
  telephone: string;
  mobile: string;
  professionalLicense: string;
  email: string;
  initialsName: string | undefined;
  constructor() {
    this.name = StringConst.empty;
    this.photoUrl = StringConst.empty;
    this.speciality = StringConst.empty;
    this.telephone = StringConst.empty;
    this.mobile = StringConst.empty;
    this.professionalLicense = StringConst.empty;
    this.email = StringConst.empty;
  }
}

export class CreditInfo {
  hasCredit: boolean;
  limitCredit: number;
  consumed: number;
  available: number;
  days: number;

  constructor(){
    this.hasCredit = BooleanCons.true;
    this.limitCredit = NumberCons.zero;
    this.consumed = NumberCons.zero;
    this.available = NumberCons.zero;
    this.days = NumberCons.zero;
  }
}

export class BillingInfo {
  invoiceDataNickName: string;
  email: string;
  zipCode: string;
  rfc: string;
  bussinessName: string;

  constructor() {
    this.invoiceDataNickName = StringConst.empty;
    this.email = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.rfc = StringConst.empty;
    this.bussinessName = StringConst.empty;
  }
}

export class RequestAdvisorModel {
  cardCode: string;
  firstName: string;
  lastName: string;
  email: string;
  advisor: string;
  constructor() {
    this.cardCode = StringConst.empty;
    this.firstName = StringConst.empty;
    this.lastName = StringConst.empty;
    this.email = StringConst.empty;
    this.advisor = StringConst.empty;
  }
}

export class AdvisorInfoSAPResponse extends BaseResponseHttp {
  response?: AdvisorInfoSAP[];

  constructor() {
    super();
    this.response = [];
  }
}

export class AdvisorInfoSAP {
  idDoctorAdvisor: number;
  slpcode: number;
  name: string;
  lastName: string;
  email: string;
  officePhone: string;
  officePhoneExt: string;
  cellPhone: string;
  birthDate: Date | null;
  advisorType: string;
  profilePictureUrl: string;
  middleName: string;
  line: string;
  constructor() {
    this.idDoctorAdvisor = 0;
    this.slpcode = 0;
    this.name = StringConst.empty;
    this.lastName = StringConst.empty;
    this.email = StringConst.empty;
    this.officePhone = StringConst.empty;
    this.officePhoneExt = StringConst.empty;
    this.cellPhone = StringConst.empty;
    this.birthDate = null;
    this.advisorType = StringConst.empty;
    this.profilePictureUrl = StringConst.empty;
    this.middleName = StringConst.empty;
    this.line = StringConst.empty;
  }
}

export class AdvisorDownloadClients extends BaseResponseHttp {
  response?: string;

  constructor() {
    super();
    this.response = StringConst.empty;
  }
}
